<template lang="pug">
page-layout#canals(:heading='heading' :num-of-slide-outs='1'	:class='{ "above-side-nav" : facilityPageState === "opened" }')
	//- + Header
	.link-container(slot='link-container')
		// ? getting rid of the map reference since link leads no where.
		//- router-link.map(to='/app/map') View on Map
		.button(@click='facilityForm') Add New Facility
	//- + Facility
	facilities-slide-out(
		slot='slideout-1'
		:state='facilityPageState'
		:asset='activeFacility'
		:asset-key='facilityKey'
		asset-name='facilities'
		@close='closeFacility'
		@edit='editFacility'
		@delete='deleteFacility'
	)
	//- Table
	asset-table(
		slot='content'
		asset-name='facilities'
		asset-key='facilitiesKey'
		search-text='Search for a Facility'
		:config='config'
		:get-all='GetFacilities'
		:get='GetFacility'
		:search='SearchFacilities'
		:download-csv='DownloadFacilitiesCSV'
		:download-pdf='DownloadFacilitiesPDF'
		@row-clicked='viewFacility'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';
import FacilitiesSlideOut from '@/components/slide-outs/facilities';

import {
	GetFacilities,
	GetFacility,
	DeleteFacility,
	DownloadFacilitiesCSV,
	DownloadFacilitiesPDF,
	SearchFacilities
} from '@/lib/API';

import Submit from '@/lib/Submit';
import { editFacility } from '@/lib/generate';

import FacilitiesConfig from '@/lib/assets/facilities';

export default {
	name : 'canals',

	data : () => ( {

		heading : {
			title       : 'Facility Information',
			description : 'Click any row to view the canal and pipe information in full',
		},

		config : {
			columns : FacilitiesConfig.columns,

			// for if you have any columns that have a dropdown
			// for it's filtering
			dropdownOptions : FacilitiesConfig.dropdownOptions,
		},

		facilityPageState : 'closed',
		activeFacility    : null,
		facilityKey       : null,

		DownloadFacilitiesCSV,
		DownloadFacilitiesPDF,
		GetFacilities,
		GetFacility,
		SearchFacilities,

	} ),

	created() {
		const { query } = this.$route;
		const { key }   = query;

		if ( key ) {
			this.viewFacility( { facilitiesKey : key } );
		}
	},

	methods : {

		facilityForm() {

			this.$store.dispatch( 'form', {
				type : 'facility',
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Creating Facility...',
						state   : 'loading'
					} );

					Submit.facility( form )
						.then( form.close() )
						.then( () => stateIndicator.resolve( 'Created Successfully' ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Create Facility', message : '' } );
						} );
				} );

		},

		viewFacility( facility ) {
			const { facilitiesKey } = facility;

			this.activeFacility = null;
			this.facilityKey    = null;

			this.facilityPageState      = 'opened';
			this.facilitiesLoadingState = 'loading';

			const displayStateOptions = {
				message        : 'Loading Facility',
				successMessage : 'Facility Loaded',
				failMessage    : 'Facility could not be loaded.',
				state          : 'loading',
			};

			this.$store.dispatch( 'loadWithDisplayState', {
				options : displayStateOptions,
				method  : () => GetFacility( facilitiesKey ),
			} )
				.then( ( apiFacility ) => {
					this.activeFacility         = apiFacility;
					this.facilityKey            = apiFacility.facilitiesKey;
					this.facilitiesLoadingState = 'loaded';
				} );

		},

		closeFacility() {
			this.facilityPageState = 'closed';
			this.activeFacility    = null;
			this.facilityKey       = null;
		},

		editFacility() {
			const { facilitiesKey } = this.activeFacility;
			const startingData      = editFacility( this.activeFacility );

			this.$store.dispatch( 'form', {
				type : 'facility',
				args : [{ edit : true }],
				startingData,
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Editing Facility...',
						state   : 'loading',
					} );

					return Submit.editFacility( form, facilitiesKey )
						.then( () => form.close() )
						.then( () => this.viewFacility( { facilitiesKey } ) )
						.then( () => stateIndicator.resolve( 'Edited Successfully' ) )
						.catch( ( error ) => {
							console.error( error );
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Edit Facility', message : '' } );
						} );

				} )
				.catch( ( e ) => {
					throw new Error( e );
				} );
		},

		async deleteFacility() {

			const stateIndicator = await this.$store.dispatch( 'displayState', {
				message : 'Deleting Facility...',
				state   : 'loading'
			} );

			DeleteFacility( this.activeFacility.facilitiesKey )
				.then( () => stateIndicator.resolve( 'Deleted Successfully' ) )
				.then( this.facilityPageState = 'closed' )
				.catch( ( err ) => {

					console.error( err );

					stateIndicator.fail( { header : 'Didn\'t Delete Facility', message : '' } );

				} );

		},

	},

	components : {
		AssetTable,
		FacilitiesSlideOut,
		PageLayout,
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.space-form.facilities-form {
	@include set-form-color( $color-primary );

	.check-box {
		margin-left: 30px;
	}
}
</style>
